"use client";

import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { Transition } from "@headlessui/react";

import Logo from "../Logo";
import { useAppContext } from "../../context/AppContext";

interface Props {
  loading: boolean;
  text?: string;
  children?: React.ReactNode
}

const LoadingScreen: React.FC<Props> = ({ loading, text, children }) => {
  const { domain } = useAppContext();
  return (
    <>
      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-300"
        enterFrom="transform opacity-0"
        enterTo="transform opacity-100"
        leave="transition ease-in duration-300"
        leaveFrom="transform opacity-100 scale-0"
        leaveTo="transform opacity-0 scale-150"
        show={loading}
      >
        <div className="grid grid-cols-1 h-full">
          <div className="mt-6 self-end place-self-center">
            <Logo className="text-5xl" domain={domain} />
          </div>
          <div className="mt-5 self-start place-self-center">
            <FontAwesomeIcon className="text-5xl text-slate-500" icon={faCircleNotch} spin />
            <div className="mt-2">{text}</div>
          </div>
        </div>
      </Transition>
      <div className={`${loading ? "hidden" : "block"} `}>{children}</div>
    </>
  );
};

export default LoadingScreen;
